import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
    SearchFilterDefinition,
    SearchFilterSelection,
    SearchFilterValue,
} from 'shared/search-engine';
import {
    MATHIA_PARCOURS_SEARCH_FILTER_CONFIG,
    MathiaFacetScope,
    MathiaSearchFilterConfig,
} from '../mathia-search-filter-config';
import {MathiaLessonsSearchFilterComponent} from '../mathia-lessons-search-filter/mathia-lessons-search-filter.component';

@Component({
    selector: 'app-mathia-parcours-search-filter',
    standalone: true,
    imports: [MathiaLessonsSearchFilterComponent],
    template: `
        <app-mathia-lessons-search-filter
            [definitions]="definitions"
            [initialSelection]="initialSelection"
            [filterConfig]="filterConfig"
            [facetScope]="facetScope"
            [resultCount]="resultCount"
            (selectionChange)="selectionChange.emit($event)">
        </app-mathia-lessons-search-filter>
    `,
})
export class MathiaParcoursSearchFilterComponent {
    @Input() public definitions: readonly SearchFilterDefinition<SearchFilterValue>[] = [];
    @Input() public initialSelection: SearchFilterSelection<SearchFilterValue> = {};
    @Input() public resultCount: number | null = null;
    @Output() public selectionChange = new EventEmitter<SearchFilterSelection<SearchFilterValue>>();

    public readonly filterConfig: readonly MathiaSearchFilterConfig[] = MATHIA_PARCOURS_SEARCH_FILTER_CONFIG;
    public readonly facetScope: MathiaFacetScope = 'lesson';
}
